{
  "words": {
    "activity": "Активность",
    "createDate": "Дата создания",
    "employee": "Сотрудник",
    "activityHistory": "История активности"
  },
  "meta": {
    "vacancyList": "Вакансии",
    "vacancyProfile": "Профиль вакансии",
    "vacancyCreate": "Создание вакансии"
  },
  "activity": "Начало работы (или период работы для временных вакансий)",
  "notFound": "Вакансий не найдено",
  "noVacancy": "Нет вакансий",
  "countingVacancy": "вакансий",
  "refreshActivity": {
    "success": "Начало работы (или период работы для временных вакансий) успешно обновлено",
    "error": "Не удалось обновить активности вакансии"
  },
  "periodActivity": "Укажите дату, когда кандидат должен приступить к работе (или укажите период работы, если вакансия временная). Синтия будет подбирать только тех, кто готов выйти на работу в это время.",
  "dates": {
    "title": "Даты вакансии",
    "createdAt": "Дата создания",
    "expiresAt": "Дата окончания действия",
    "notSet": "Не указана"
  },
  "breadcrumbs": {
    "vacancies": "Вакансии"
  },
  "since": {
    "lowerCase": "с",
    "upperCase": "С"
  },
  "to": {
    "lowerCase": "до",
    "upperCase": "До"
  },
  "template": {
    "title": "Шаблон вакансий",
    "description": "Выберите готовый шаблон из ранее созданных",
    "placeholder": "Выберите шаблон"
  },
  "newVacancy": "Новая вакансия",
  "vacancy": {
    "status": {
      "new": "Новая",
      "inProgress": "Идет подбор",
      "suspended": "Подбор приостановлен",
      "cancelled": "Подбор отменен",
      "completed": "Подбор выполнен",
      "archived": "В архиве",
      "actions": {
        "launch": "Запустить",
        "suspend": "Приостановить",
        "cancel": "Отменить подбор"
      },
      "title": "Статус вакансии",
      "error": "Не удалось изменить статус вакансии",
      "active": "Активна",
      "activeCustom": {
        "actives": "Активные",
        "inactives": "Неактивные",
        "always": "Активна всегда",
        "period": "Активна период"
      },
      "inactive": "Неактивна"
    },
    "create": "Создать вакансию"
  },
  "cleaningManager": "Менеджер объекта по клинингу",
  "header": {
    "createdDate": "Дата создания:",
    "modifiedDate": "Дата изменения",
    "deleteVacancy": "Удалить вакансию"
  },
  "responsibleUser": {
    "title": "Ответственный сотрудник",
    "description": "Выберите ответственного сотрудника компании-нанимателя"
  },
  "filters": {
    "region": "Регион",
    "city": "Город"
  },
  "mainInfo": {
    "region": "Регион",
    "city": "Город",
    "activitySphere": "Профессия",
    "interviewFinalMessage": "Сообщение для заинтересованных кандидатов"
  },
  "edit": {
    "template": {
      "title": "Шаблон вакансий",
      "description": "Выберите готовый шаблон из ранее созданных"
    },
    "interviewFinalMessage": {
      "title": "Сообщение для заинтересованных кандидатов",
      "description": "Как только лучший кандидат будет найден Синтия свяжется с ним и предложит Вашу вакансию. Если кандидат подтвердит готовность поработать на Вашей вакансии, Синтия вышлет кандидату финальное сообщение из данного поля. Вы можете указать в этом поле адрес или прикрепите ссылку куда подойти кандидату для оформления, в какое время подойти и кого спросить.",
      "placeholder": "Введите описание"
    },
    "city": {
      "title": "Город",
      "description": "Адрес, где будет работать сотрудник"
    },
    "activitySphere": {
      "title": "Профессия",
      "description": "Выберите все подходящие профессии для вакансии",
      "placeholder": "Выберите",
      "autoFill": "Автозаполнение"
    }
  },
  "create": {
    "minPeriodActivityError": "Дата начала активности должна быть больше или равна текущей дате",
    "periodActivityFromError": "Обязательное поле",
    "periodActivityToError": "Обязательное поле"
  },
  "generate": {
    "chatCreate": "Créer avec Cynthia",
    "chatMessage": "Bonjour Cynthia, je souhaite créer une offre d’emploi.",
    "button": "Сгенерировать вакансию",
    "manualCreate": "Ручное создание",
    "title": "Генерация вакансии",
    "pending": "Пожалуйста, подождите — формируем вакансию на основе вашего запроса",
    "error": "По вашему запросу не удалось сгенерировать вакансию",
    "close": "Закрыть",
    "cancel": "Отмена",
    "submit": "Сгенерировать",
    "vacancyName": {
      "label": "Название вакансии",
      "description": "Название должности, кого планируется нанимать. Максимальное количество символов - 250",
      "placeholder": "Введите название",
      "maxLength": "Превышено максимальное количество символов"
    },
    "generationRequest": {
      "label": "Запрос на генерацию",
      "description": "Опишите вакансию простыми словами: кого ищете, какие задачи и условия. Синтия сгенерирует вакансию на основе вашего запроса. Максимальное количество символов - 3000",
      "placeholder": "Введите запрос на генерацию в свободной форме",
      "required": "Введите запрос на генерацию в свободной форме",
      "maxLength": "Превышено максимальное количество символов"
    }
  },
  "tariff": {
    "title": "Тариф",
    "show": "Показать",
    "hide": "Скрыть",
    "costLine1": "Стоимость",
    "costLine2": "за выбранного кандидата",
    "selectTariffAria": "Выбор тарифа",
    "loadError": "Не удалось загрузить тарифы",
    "noTariffs": "Нет доступных тарифов",
    "historyTitle": "История изменений",
    "historyAria": "История изменений тарифа",
    "columnActivationDate": "Дата установки",
    "columnTariffName": "Наименование тарифа",
    "modalTitle": "Выбор тарифа",
    "cancel": "Отмена",
    "save": "Сохранить",
    "back": "Назад"
  },
  "ratingBanner": {
    "summary": "Требуется обратная связь · {{count}}",
    "previous": "Предыдущий запрос",
    "next": "Следующий запрос",
    "hired": {
      "question": "Кандидат был принят на работу по вакансии: {{vacancyName}}?"
    },
    "interview": {
      "question": "Состоялось ли собеседование с кандидатом по вакансии: {{vacancyName}}?",
      "cancellationModal": {
        "title": "Укажите причину",
        "description": "Пожалуйста, укажите причину несостоявшегося собеседования",
        "cancel": "Отмена",
        "submit": "Отправить"
      }
    },
    "yes": "Да",
    "no": "Нет",
    "candidateDetails": {
      "contactPhone": "Контактный телефон"
    },
    "rejection": {
      "questionBeforeName": "Пожалуйста, укажите причину отказа кандидату ",
      "questionAfterName": " по вакансии: {{vacancyName}}?",
      "description": "Укажите причину, по которой кандидат не был нанят, это займет менее минуты. Кандидат не увидит ваш ответ",
      "leaveAnswer": "Оставить ответ",
      "remindLater": "Напомнить позже",
      "skip": "Пропустить",
      "form": {
        "title": "Причина отказа",
        "checkboxHint": "Активируйте чекбокс для подходящих утверждений",
        "reasonRequired": "Выберите хотя бы одну причину",
        "commentLabel": "Комментарий",
        "commentDescription": "Укажите комментарий по желанию. Максимальное количество символов — {{max}}",
        "commentPlaceholder": "Введите комментарий",
        "commentMaxLength": "Превышено максимальное количество символов",
        "cancel": "Отмена",
        "submit": "Отправить"
      },
      "successModal": {
        "title": "Благодарим за ваш ответ!",
        "description": "Мы обязательно учтем его, чтобы сделать сервис подбора кандидатов еще лучше",
        "confirm": "Хорошо"
      }
    },
    "review": {
      "questionBeforeName": "Оцените работу кандидата ",
      "questionAfterName": " по вакансии: {{vacancyName}}?",
      "description": "Оставьте отзыв о кандидате, это займет менее минуты. Кандидат не увидит ваш отзыв",
      "leaveReview": "Оставить отзыв",
      "remindLater": "Напомнить позже",
      "skip": "Пропустить",
      "form": {
        "title": "Отзыв о кандидате",
        "checkboxHint": "Активируйте чекбокс для подходящих утверждений",
        "commentLabel": "Комментарий",
        "commentDescription": "Укажите комментарий по желанию. Максимальное количество символов — {{max}}",
        "commentPlaceholder": "Введите комментарий",
        "commentMaxLength": "Превышено максимальное количество символов",
        "cancel": "Отменить",
        "submit": "Отправить"
      },
      "successModal": {
        "title": "Благодарим за ваш отзыв!",
        "description": "Мы обязательно учтем его, чтобы сделать сервис подбора кандидатов еще лучше",
        "confirm": "Хорошо"
      }
    }
  }
}
